import { Activity, ArrowUp, Plus, Heart } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { money, timeAgo } from "@/lib/format";

const hypeCopy = (ev) => {
    if (ev.type === "passed") return "took Crowd #1";
    return "joined the board";
};

export const LatestActivityFeed = ({ items, loading, updated, variant = "auction" }) => (
    <Card className="bg-card border-border p-4" data-testid="activity-feed">
        <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
                <Activity className="h-4 w-4 text-brand" />
                <h3 className="text-sm font-semibold tracking-wide uppercase text-muted-foreground">Latest activity</h3>
            </div>
            {updated ? (
                <span className="h-2 w-2 rounded-full bg-brand animate-pulse-dot" title="Live" />
            ) : null}
        </div>
        {loading ? (
            <div className="space-y-2">
                {[0, 1, 2, 3].map((i) => (
                    <Skeleton key={i} className="h-10 w-full rounded-lg" />
                ))}
            </div>
        ) : items && items.length ? (
            <div className="space-y-2 max-h-[360px] overflow-y-auto pr-1">
                {items.map((ev) => (
                    <div key={ev.id} data-testid={`activity-item-${ev.id}`} className="flex items-center gap-3 text-sm animate-rise">
                        <span className={`grid place-items-center h-7 w-7 rounded-md shrink-0 ${
                            ev.type === "listed" || ev.type === "new_listing"
                                ? "bg-brand/15 text-brand"
                                : "bg-heat/15 text-heat"
                        }`}>
                            {ev.type === "listed" || ev.type === "new_listing"
                                ? <Plus className="h-3.5 w-3.5" />
                                : ev.type === "passed"
                                    ? <Heart className="h-3.5 w-3.5" />
                                    : <ArrowUp className="h-3.5 w-3.5" />}
                        </span>
                        <div className="flex-1 min-w-0">
                            <p className="truncate">
                                <span className="font-medium">{ev.display_name}</span>{" "}
                                <span className="text-muted-foreground">
                                    {variant === "hype"
                                        ? hypeCopy(ev)
                                        : ev.type === "new_listing" ? "joined the board at" : "raised to"}
                                </span>
                                {variant === "hype" ? (
                                    ev.like_count != null ? (
                                        <>
                                            {" "}
                                            <span className="font-semibold tabular">{ev.like_count}</span>
                                            <span className="text-muted-foreground"> likes</span>
                                        </>
                                    ) : null
                                ) : (
                                    <>
                                        {" "}
                                        <span className="font-semibold tabular">{money(ev.amount)}</span>
                                    </>
                                )}
                            </p>
                        </div>
                        <span className="text-[11px] text-muted-foreground shrink-0">{timeAgo(ev.ts)}</span>
                    </div>
                ))}
            </div>
        ) : (
            <p className="text-sm text-muted-foreground py-4 text-center">No activity yet. Be the first.</p>
        )}
    </Card>
);
